import { createTableFiltersState } from '@/utils/table-filters';

import { BroadcastScheduleClipsFilters } from '../../types';

export const useBroadcastScheduleClipsFilters =
  createTableFiltersState<BroadcastScheduleClipsFilters>({
    defaultFilterValues: {
      workspaces: [] as string[],
    },
  });
